module.exports = __webpack_public_path__ + "papperPlane.e0c361b48b6f8f8c3750.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/decorativeElements/papperPlane.png
// module id = ../../../../../src/assets/decorativeElements/papperPlane.png
// module chunks = 0